import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { saveAs } from 'file-saver';
import { stringDate } from 'helpers/date';
import cookie from 'react-cookies';

export const checkTypePricingApi = createApi({
  reducerPath: 'checkTypePricingApi',
  tagTypes: ['CheckTypePricing'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URl}/check_type_pricing`,
    prepareHeaders: headers => {
      headers.set('Authorization', `Bearer ${cookie.load('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getCheckTypePricing: builder.query({
      query: () => ({ url: '/' }),
      transformResponse: ({ result }) => result ?? [],
      providesTags: ['CheckTypePricing'],
    }),
    updateCheckTypePricing: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/${id}`,
        method: 'PUT',
        body,
      }),
      transformResponse: ({ result }) => result ?? {},
      invalidatesTags: ['CheckTypePricing'],
    }),
    getCompanyChecksReport: builder.query({
      queryFn: async (arg, api, extraOptions, baseQuery) => {
        const { data: file } = await baseQuery({
          url: '/company_checks_report',
          responseHandler: async response => {
            const blob = await response.blob();
            return blob;
          },
          cache: 'no-cache',
        });
        saveAs(file, `${stringDate()}_company_checks_pricing.csv`);
        return { data: null };
      },
    }),
  }),
});

export const {
  useGetCheckTypePricingQuery,
  useUpdateCheckTypePricingMutation,
  useLazyGetCompanyChecksReportQuery,
} = checkTypePricingApi;
